<template>
  <div class="RwvImageCropper">
    <!-- <b-card> -->
      <b-form-group
        :id="'input-group-upload-crop-image-' + index"
        :label-for="'input-upload-crop-image-' + index"
        v-b-tooltip.hover
        title="Vorschaubild">

        <!-- <b-form-group
          id="input-group-upload-image-link"
          label-for="input-upload-image"
          v-b-tooltip.hover>

          <b-form-input
            id="input-upload-image-link"
            v-model="cropImg"
            @change="changedLink"
            placeholder="Link">
            </b-form-input>
        </b-form-group> -->

        <b-form-file
          :id="'input-upload-crop-image-' + index"
          v-model="file"
          @change="changedImage"
          accept="image/*"
          placeholder="Datei auswählen ..."
          drop-placeholder="Datei hierher ziehen ...">

        </b-form-file>

      </b-form-group>
    <!-- </b-card> -->

    <div class="mt-3" v-bind:class="{ hidden: !image }">

      <vue-cropper
        class="cropper"
        ref="cropper"
        :src="image"
        :cropmove="cropImage"
        alt="Source Image"
        :ready="cropImage">
      </vue-cropper>

      <b-button v-on:click="deleteImage" variant="danger"><i class="material-icons">delete</i></b-button>

      <!-- Normal Actions -->
      <b-button-group v-if="!isCropActive">
        <b-button v-on:click="toggleCropActive"><i class="material-icons">crop</i></b-button>
      </b-button-group>

      <!-- Crop Actions -->
      <b-button-group v-else>
        <b-button v-on:click="toggleCropActive" variant="warning"><i class="material-icons">close</i></b-button>
        <b-button v-on:click="toggleLock" v-if="!isLocked">
          <i class="material-icons">lock</i>
        </b-button>
        <b-button variant="outline-secondary" v-on:click="toggleLock" v-else>
          <i class="material-icons">lock_open</i>
        </b-button>
        <b-button v-on:click="cropImage" variant="primary"><i class="material-icons">done</i></b-button>
      </b-button-group>
    </div>

    <b-modal id="modal-confirmation-delete-image" title="Sicher?">
      <p class="my-4">Sind Sie sich sicher, dass Sie das Bild entfernen wollen?</p>
      <p class="my-4">Sichern Sie das Bild wahlweise durch Rechtsklick auf <code>Bild -> Bild speichern unter</code></p>
    </b-modal>

    <div v-if="!saved">
      <p v-if="!uploading">
        <b-button
          size="sm"
          variant="warning"
          v-on:click="uploadImage">Hochladen
        </b-button>
        Achtung! Ungespeicherte Änderungen.
      </p>
      <div class="text-center my-4" v-else>
        <b-spinner label="Spinning"></b-spinner> Am hochladen
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import { singleUpload } from "@/common/aws.service";

export default {
  name: "RwvImageCropper",
  components: {
    VueCropper
  },
  props: {
    srcImage: {
      type: String,
      default: ""
    },
    resizedMaxWidth: {
      type: Number,
      default: 390
    },
    resizedMaxHeight: {
      type: Number,
      default: 550
    },
    targetFolder: {
      type: String,
      default: "defaultImageFolder"
    },
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      file: null,
      isCropActive: false,
      isLocked: false,
      image: this.srcImage,
      cropImg: "",
      cropFile: null,
      deactivateAfterReady: true,
      saved: true,
      uploading: false
    }
  },
  methods: {
    changedImage(image) {
      console.log("changedImage")
      var me = this
      var reader = new FileReader();
      me.cropFile = image.target.files[0]
      reader.readAsDataURL(image.target.files[0]);

      reader.onload = function () {
        me.image = reader.result

        if (!me.isCropActive) {
          me.$refs.cropper.enable()
          me.cropImg = me.image
          me.$refs.cropper.replace(me.image)
          me.$refs.cropper.clear()
          me.$refs.cropper.reset()
          me.$refs.cropper.disable()
          console.log("if !me.isCropActive")
        }
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      this.saved = false
    },
    setCropperHeight() {
      var img = new Image();
      var me = this;

      img.onload = function() {
        var imgWidth = img.naturalWidth,
            imgHeight = img.naturalHeight;
        me.$refs.cropper.setCropBoxData(0, 0, imgWidth, imgHeight)
      };

      img.src = me.image;
    },
    cropImage() {
      var me = this
      // Check if it should deactivate (used for initializing with a new image when crop is deactivated)
      if (this.deactivateAfterReady) {
        console.log("deactivateAfterReady")
        this.deactivateAfterReady = false
        this.deactivateCrop()
      } else {
        console.log("cropImage")

        // get image data for post processing, e.g. upload or setting image src
        this.$refs.cropper.getCroppedCanvas({
          maxWidth: 2160,
          maxHeight: 1200,
        }).toBlob(function(blob) {
          var croppedFile = new File([blob], 'cropped_file.png');
          me.cropFile = croppedFile
          // this.$emit('cropImage', this.cropImg)
        }, 'image/png', 0.9);

        this.cropImg = this.$refs.cropper.getCroppedCanvas({
          maxWidth: 2160,
          maxHeight: 1200,
        }).toDataURL();

        var resizedCropImg = this.$refs.cropper.getCroppedCanvas({
          maxWidth: this.resizedMaxWidth,
          maxHeight: this.resizedMaxWidth

        }).toDataURL();
        this.$emit('cropImage', this.cropImg, this.index)
        this.$emit('resizedCropImage', resizedCropImg, this.index)

        this.saved = false
      }
    },
    uploadImage() {
      console.log("upload Image")
      var me = this
      this.uploading = true
      singleUpload(this.cropFile, this.targetFolder).then(function(location) {
        me.uploading = false
        me.saved = true
        me.cropImg = location
        console.log("single Upload");
        me.$emit('cropImage', me.cropImg, me.index)
      })
    },
    deleteImage: function (e) {
      // modal-confirmation-delete-image
      this.image = '';
      this.file = null
      this.$emit('deleteImage', this.index)
    },
    toggleCropActive() {
      this.isCropActive = !this.isCropActive

      // If is not active after toggle
      if (!this.isCropActive) {
        this.deactivateCrop()
      } else {
        this.$refs.cropper.enable()
        this.cropImg = this.image
        this.$refs.cropper.replace(this.image)
      }
    },
    deactivateCrop() {
        this.$refs.cropper.clear()
        this.$refs.cropper.reset()
        this.$refs.cropper.disable()
        this.isLocked = false
        // this.cropImage();
    },
    toggleLock() {
      this.isLocked = !this.isLocked

      if (!this.isLocked) {
        this.$refs.cropper.enable()
      } else {
        this.$refs.cropper.disable()
      }
    }
  }
}
</script>

<style lang="scss">
.hidden {
  display: none;
}
</style>
